<template>
  <div>
    <v-container>
      <h1>{{ title }}</h1>
      <v-row>
        <v-col cols="12" xs="12" sm="12" md="12">
          <v-btn icon text :to="`/pr-summary`">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
          <custom-datepicker :class-padding="classPadding" label="Date" v-model="model.date"></custom-datepicker>
        </v-col>
        <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
          <!-- <payroll-location
            :class-padding="classPadding"
            :title="'Payroll Locations'"
            :label="'Payroll Location'"
            :required="true"
            v-model="selectedPayLoc"
            :code-value="false"
          ></payroll-location>-->
          <v-text-field v-model="model.locName" :class="classPadding"></v-text-field>
        </v-col>
        <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
          <!-- <designation
            :class-padding="classPadding"
            :title="'Designation'"
            :label="'Designation'"
            v-model="selectedDesig"
          ></designation>-->
          <v-text-field v-model="model.desDesc" :class="classPadding"></v-text-field>
        </v-col>

        <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
          <!-- <department
            :class-padding="classPadding"
            :title="'Department'"
            :label="'Department'"
            v-model="selectedDep"
          ></department>-->
          <v-text-field v-model="model.depDesc" :class="classPadding"></v-text-field>
        </v-col>
        <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
          <!-- <section-lookup
            :class-padding="classPadding"
            :title="'Section'"
            :label="'Section'"
            v-model="selectedSection"
          ></section-lookup>-->
          <v-text-field v-model="model.secDesc" :class="classPadding"></v-text-field>
        </v-col>

        <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
          <v-text-field :class="classPadding" label="No. of needed" v-model="model.noOfNeed"></v-text-field>
        </v-col>
        <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
          <!-- <custom-datepicker
            :class-padding="classPadding"
            label="Start of Work"
            v-model="model.startOfWork"
            :readOnly="true"
          ></custom-datepicker>-->
          <v-text-field :class="classPadding" label="Start of Work" v-model="model.startOfWork"></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
          <v-select
            :class="classPadding"
            label="Sex Preference"
            :items="sex"
            item-text="text"
            item-value="value"
            v-model="model.sexPreferences"
          ></v-select>
        </v-col>
        <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
          <!-- <employee-status
            :class-padding="classPadding"
            :title="'Employee Status'"
            :label="'Hiring Preferences'"
            v-model="seletedEmpStat"
          ></employee-status>-->
          <v-text-field v-model="model.hiringPreferences" :class="classPadding"></v-text-field>
        </v-col>
        <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
          <v-text-field
            :class="classPadding"
            label="Months"
            type="number"
            v-model="model.hiringPreferencesMonth"
          ></v-text-field>
        </v-col>
        <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
          <v-select
            :class="classPadding"
            label="Reason for Requisition"
            :items="vacancies"
            item-text="text"
            item-value="value"
            v-model="model.reasonForRequisition"
          ></v-select>
        </v-col>
        <v-col
          cols="12"
          xs="12"
          sm="6"
          md="5"
          :class="classPadding"
          v-if="model.reasonForRequisition == 'V'"
        >
          <v-text-field
            :class="classPadding"
            placeholder=" "
            label="Cause by resignation/termination/promotion/transfer of"
            v-model="model.vacancyTransferOf"
          ></v-text-field>
        </v-col>
        <v-col
          cols="12"
          xs="12"
          sm="6"
          md="3"
          :class="classPadding"
          v-if="model.reasonForRequisition == 'V'"
        >
          <!-- <custom-datepicker
            :class-padding="classPadding"
            label="Effectivity Date"
            v-model="model.vacancyEffectiveOn"
          ></custom-datepicker>-->
          <v-text-field
            :class="classPadding"
            label="Effectivity Date"
            v-model="model.vacancyEffectiveOn"
          ></v-text-field>
        </v-col>
        <v-col
          cols="12"
          xs="12"
          sm="6"
          md="5"
          :class="classPadding"
          v-if="model.reasonForRequisition == 'N'"
        >
          <v-text-field
            :class="classPadding"
            placeholder=" "
            label="Give Justification"
            v-model="model.newPositionJustification"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" xs="12" sm="12" md="12" :class="classPadding">
          <v-textarea label="Brief Description of Duties" v-model="model.dutiesDescription"></v-textarea>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <h5>Qualification Required</h5>
        </v-col>
        <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
          <v-text-field
            :class="classPadding"
            label="1. Education and Training"
            v-model="model.reqQualificationEducAndTrain"
          ></v-text-field>
        </v-col>
        <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
          <v-text-field
            :class="classPadding"
            label="2. Work Experience"
            v-model="model.reqQualificationWorkExp"
          ></v-text-field>
        </v-col>
        <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
          <v-text-field
            :class="classPadding"
            label="3. Special Qualification"
            v-model="model.reqSpecQualification"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
          <!-- <emp-lookup
            :class-padding="classPadding"
            v-model="selectedEmp"
            label="Requested By"
            title="Employee"
            :code-value="false"
            :off-remarks="true"
          ></emp-lookup>-->
          <v-text-field :class="classPadding" label="Requested By" v-model="model.fullName"></v-text-field>
        </v-col>
        <v-col cols="12" xs="12" sm="6" md="6" :class="classPadding">
          <!-- <v-file-input
            label="Attachment"
            ref="webLogoReports"
            v-model="attachment"
            :class="classPadding"
          ></v-file-input>
          <v-btn color="primary" @click.stop="upload" :loading="isUploading">Upload</v-btn>-->
          <v-data-table
            :items="attachments"
            :headers="attachmentHeaders"
            v-if="attachments.length > 0"
          >
            <template v-slot:item.actions="{ item }">
              <v-btn text outlined @click.prevent="openFile(item)">View</v-btn>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <h5>Personnel Department</h5>
        </v-col>
        <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
          <v-text-field
            :class="classPadding"
            label="Presenting Staff"
            v-model="model.personnelDepStaff"
          ></v-text-field>
        </v-col>
        <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
          <v-text-field
            :class="classPadding"
            label="Per Manning Guide"
            v-model="model.personnelDepManningGuide"
          ></v-text-field>
        </v-col>
        <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
          <v-text-field
            :class="classPadding"
            label="Hire-in Rate"
            v-model="model.personnelDepHireInRate"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" xs="12" sm="12" md="12" :class="classPadding">
          <v-textarea v-model="model.remarks" :class="classPadding" label="Approver Remarks"></v-textarea>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" xs="12" sm="12" md="12" :class="classPadding">
          <!-- <v-btn color="success" @click.stop="approve" :loading="isApproving">Approve</v-btn>&nbsp;
          <v-btn @click.stop="decline" :loading="isDeclining">Decline</v-btn>-->
          <v-btn @click.stop="preview" :loading="isPreviewing" v-if="userAccess.print >= 1">Preview</v-btn>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import CustomDatepicker from "../../../../components/CustomDatepicker";
import { isNullOrUndefined } from "../../../../validation/validation";
import moment from "moment";
import userAccessMixin from "../../../../mixins/userAccessMixin";
const API_ENDPOINT_OAG = "/api/oApproverGroup";
const API_ENDPOINT = "/api/pr";
export default {
  metaInfo: {
    title: "Personnel Requisition Summary",
    titleTemplate: `%s - ${process.env.VUE_APP_NAME}`
  },
  mixins: [userAccessMixin],
  components: {
    CustomDatepicker
    // PayrollLocation,
    // Designation,
    // Department,
    // SectionLookup: Section,
    // EmployeeStatus,
    // EmpLookup
  },
  data: () => ({
    title: "Personnel Requisition Summary",
    classPadding: "my-0 py-0",
    model: {
      reasonForRequisition: "V"
    },
    sex: [
      { text: "Either Sex", value: "eitherSex" },
      { text: "Male", value: "Male" },
      { text: "Female", value: "Female" }
    ],
    vacancies: [
      { text: "Vacancy", value: "V" },
      { text: "New Position", value: "N" }
    ],
    attachment: null,
    groupCodes: [],
    selectedGroup: null,
    items: [],
    headers: [
      {
        text: "",
        value: "actions",
        sortable: false
      },
      {
        text: "Approver",
        value: "fullName",
        sortable: true
      },
      {
        text: "Code",
        value: "approverCode",
        sortable: true
      },
      {
        text: "Position Description",
        value: "desDesc",
        sortable: true
      },
      {
        text: "Approver Type",
        value: "approverType",
        sortable: true
      }
    ],
    loading: false,
    isUploading: false,
    attachments: [],
    attachmentHeaders: [
      {
        text: "",
        value: "actions",
        sortable: false
      },
      {
        text: "File Name",
        value: "fileName",
        sortable: true
      },
      {
        text: "Created By",
        value: "createdBy",
        sortable: true
      }
    ],
    selectedStatus: null,
    remarks: null,
    isPreviewing: false
  }),
  methods: {
    preview() {
      let { prfNo } = this.$route.params;
      let routeData = this.$router.resolve({
        name: "report-viewer",
        query: { prfNo: prfNo, type: "pr-preview" }
      });
      window.open(routeData.href, "_blank");
      //this.isPreviewing = true;
    },
    getByGroupCode() {
      var groupType = "PR";
      this.$axios
        .get(`${API_ENDPOINT_OAG}/${groupType}`)
        .then(({ data }) => {
          this.groupCodes = data;
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        });
    },
    getMember(groupCode) {
      this.$axios
        .get(`${API_ENDPOINT}/${groupCode}`)
        .then(({ data }) => {
          this.items = data;
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        });
    },
    upload() {
      let { prfNo } = this.$route.params;
      this.isUploading = true;
      var formData = new FormData();
      formData.append("attachment", this.attachment);
      this.$axios({
        method: "POST",
        url: `${API_ENDPOINT}/upload-prfNo?prfNo=${prfNo}`,
        data: formData,
        config: {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        }
      })
        .then(({ data }) => {
          this.$toast.success(data.message);
          this.attachment = null;
          this.getAttachment(prfNo);
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.isUploading = false;
        });
    },
    getByPRFNo(prfNo) {
      this.$axios
        .get(`${API_ENDPOINT}/approval/${prfNo}`)
        .then(({ data }) => {
          if (!isNullOrUndefined(data.startOfWork)) {
            data.startOfWork = moment(data.startOfWork).format("MM/DD/YYYY");
          }
          if (!isNullOrUndefined(data.vacancyEffectiveOn)) {
            data.vacancyEffectiveOn = moment(data.vacancyEffectiveOn).format(
              "MM/DD/YYYY"
            );
          }
          this.model = data;
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        });
    },
    getAttachment(prfNo) {
      this.$axios
        .get(`${API_ENDPOINT}/attachment/${prfNo}`)
        .then(({ data }) => {
          this.attachments = data;
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        });
    },
    openFile(item) {
      var subPath = process.env.VUE_APP_PATH;
      // var newSubPath = "";
      // if (subPath.length > 1) {
      //   newSubPath = subPath.slice(0, -1);
      // } else {
      //   newSubPath = subPath.slice(0, -1);
      // }
      window.open(`${subPath.slice(0, -1)}${item.filePath}`);
    }
  },
  computed: {
    // enableApproveButton() {
    //   let { status } = this.$route.query;
    //   if (isNullOrUndefined(status)) return false;
    //   if (status == "APPROVED" || status == "DECLINED" || status == "WAITING")
    //     return false;
    //   return true;
    // }
  },
  created() {
    let { prfNo } = this.$route.params;
    this.getByGroupCode();
    this.getByPRFNo(prfNo);
    this.getAttachment(prfNo);

    this.getUserAccessRights("PRSUMMARY");
  },
  watch: {
    selectedGroup(val) {
      this.getMember(val);
    }
  }
};
</script>
